import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { FaLongArrowAltUp, FaLongArrowAltDown } from 'react-icons/fa'
import Swal from 'sweetalert2'
import { ModalInfoview } from '../../service/components/Modals'
import { okidentitys } from '../../service/project'

function AdminUserPage({ userlist, projectlist, stamplist }) {
    const [sortedList, setSortedList] = useState([])
    const [openRow, setOpenRow] = useState(null)

    // 등급 필터: all | 0 | 1 | 2 | 3
    const [gradeFilter, setGradeFilter] = useState('all')

    // 신원인증 파일 모달용
    const [modalFile, setModalFile] = useState(null)

    useEffect(() => {
        if (Array.isArray(userlist)) {
            setSortedList(userlist)
        }
    }, [userlist])

    const columns = [
        '회사명',
        '아이디',
        '이름',
        '이메일',
        '번호',
        '날인',
        '비밀서지',
        '등록상태',
        '프로젝트',
        '회원등급',
    ]

    // 전체 폭 기준 자동 분배
    // const columnTemplate = '1.4fr 1.1fr 0.9fr 2fr 1.3fr 0.8fr 1.2fr 1.6fr 2fr 1fr'
    const columnTemplate = '1.4fr 1.1fr 0.9fr 2fr 1.2fr 0.7fr 0.7fr 1.2fr 1.2fr 0.8fr'

    // 인덱스 → 기본 정렬 키
    const sortKeyMap = {
        0: 'company',
        1: 'userId',
        2: 'uName',
        3: 'email',
        4: 'uPhone',
        // 5는 '날인' 컬럼이라 stamplist로 처리 (아래 별도 분기)
    }

    // userId 기준 날인 개수 구하는 헬퍼
    const getStampCount = (userId) => {
        if (!Array.isArray(stamplist)) return 0
        return stamplist.filter((s) => s.userId === userId).length
    }

    const sortData = (idx, dir) => {
        if (!Array.isArray(sortedList)) return

        const sorted = [...sortedList]

        // 5번 인덱스(날인) 은 stamplist 기준 정렬
        if (idx === 5) {
            sorted.sort((a, b) => {
                const av = getStampCount(a.userId)
                const bv = getStampCount(b.userId)

                return dir === 'up' ? av - bv : bv - av
            })
        } else {
            const key = sortKeyMap[idx]
            if (!key) return

            sorted.sort((a, b) => {
                let av = a[key] || ''
                let bv = b[key] || ''

                if (typeof av === 'string') av = av.toLowerCase()
                if (typeof bv === 'string') bv = bv.toLowerCase()

                return dir === 'up' ? (av >= bv ? 1 : -1) : av <= bv ? 1 : -1
            })
        }

        setSortedList(sorted)
    }

    // 등록상태 계산
    const getStatusList = (user) => {
        const myinfo = user.uPhone && user.position && user.companypart
        const company =
            user.company &&
            user.representative &&
            user.companytype &&
            user.companyregiNum &&
            user.sector1 &&
            user.sector2 &&
            user.companyNum &&
            user.taxmail &&
            user.companyaddressf &&
            user.companyaddressm

        const document = !!user.identity

        return [
            { label: '기본정보', ok: !!myinfo },
            { label: '회사정보', ok: !!company },
            { label: '신원인증', ok: !!document },
        ]
    }

    // 등급 코드 추출 (0/1/2/3 or null)
    const getGradeCode = (user) => {
        const raw =
            user.ugrade !== undefined && user.ugrade !== null
                ? user.ugrade
                : user.uGrade !== undefined && user.uGrade !== null
                ? user.uGrade
                : user.grade

        if (raw === undefined || raw === null) return null

        const code = Number(raw)
        return Number.isNaN(code) ? null : code
    }

    // 회원 등급 텍스트 변환
    const getGradeLabel = (user) => {
        const code = getGradeCode(user)

        switch (code) {
            case 0:
                return '수요기업'
            case 1:
                return '관리자'
            case 2:
                return '파트너'
            case 3:
                return '시니어'
            default:
                return '미지정'
        }
    }
    // 등급 필터 적용된 리스트
    const filteredList = Array.isArray(sortedList)
        ? sortedList.filter((user) => {
              if (gradeFilter === 'all') return true
              const code = getGradeCode(user)
              return code === gradeFilter
          })
        : []

    // 신원인증 확인하기 버튼 로직 (서버 + 로컬 상태 반영)
    const handleOkIdentity = (user) => {
        Swal.fire({
            title: '신원확인을 완료하시겠습니까?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: '아니요',
            confirmButtonText: '네',
        }).then((result) => {
            if (result.isConfirmed) {
                okidentitys(user.userId).then(() => {
                    // 로컬 리스트에 identity 반영
                    setSortedList((prev) => prev.map((u) => (u.userId === user.userId ? { ...u, identity: 1 } : u)))

                    Swal.fire('신원인증이 완료되었습니다', '확인 버튼을 눌러 주세요', 'success')
                })
            }
        })
    }

    return (
        <Wrap>
            <FilterBar>
                <FilterButton type="button" onClick={() => setGradeFilter('all')} active={gradeFilter === 'all'}>
                    전체회원
                </FilterButton>
                <FilterButton type="button" onClick={() => setGradeFilter(0)} active={gradeFilter === 0}>
                    수요기업
                </FilterButton>
                <FilterButton type="button" onClick={() => setGradeFilter(2)} active={gradeFilter === 2}>
                    파트너
                </FilterButton>
                <FilterButton type="button" onClick={() => setGradeFilter(3)} active={gradeFilter === 3}>
                    시니어
                </FilterButton>
                {/* <FilterButton type="button" onClick={() => setGradeFilter(1)} active={gradeFilter === 1}>
                    관리자
                </FilterButton> */}
            </FilterBar>

            <Table>
                <Header columns={columnTemplate}>
                    {columns.map((col, idx) => (
                        <HeaderCell key={idx}>
                            <HeaderInner>
                                <span className="label">{col}</span>
                                {idx <= 5 && (
                                    <SortWrap>
                                        <FaLongArrowAltUp size={14} onClick={() => sortData(idx, 'up')} />
                                        <FaLongArrowAltDown size={14} onClick={() => sortData(idx, 'down')} />
                                    </SortWrap>
                                )}
                            </HeaderInner>
                        </HeaderCell>
                    ))}
                </Header>

                <Body>
                    {filteredList.map((user) => {
                        const plist = Array.isArray(projectlist)
                            ? projectlist.filter((p) => p.userId === user.userId)
                            : []

                        // 날인 개수
                        const stampCount = getStampCount(user.userId)
                        const statusList = getStatusList(user)

                        const totalProject = plist.length
                        const runningProject = plist.filter(
                            (p) => p.adminstatus === '계약중' || p.adminstatus === '프로젝트진행중',
                        ).length
                        const doneProject = plist.filter((p) => p.adminstatus === '프로젝트완료').length

                        return (
                            <React.Fragment key={user.id}>
                                <Row
                                    columns={columnTemplate}
                                    onClick={() => setOpenRow(openRow === user.id ? null : user.id)}
                                >
                                    <Cell>{user.company || '미작성'}</Cell>
                                    <Cell>{user.userId}</Cell>
                                    <Cell>{user.uName}</Cell>
                                    <Cell>{user.email}</Cell>
                                    <Cell>{user.uPhone || '미작성'}</Cell>

                                    {/* 날인: stampCount개 */}
                                    <Cell>{stampCount}개</Cell>

                                    <Cell>{user.confidentiality ? '작성완료' : '미작성'}</Cell>

                                    {/* 등록상태 */}
                                    <Cell>
                                        <StatusWrap>
                                            {statusList.map((st) => (
                                                <StatusBadge key={st.label} ok={st.ok}>
                                                    {st.label} : {st.ok ? '완료' : '미완료'}
                                                </StatusBadge>
                                            ))}
                                        </StatusWrap>
                                    </Cell>

                                    {/* 프로젝트 요약 */}
                                    <Cell>
                                        <ProjectInfo>
                                            <div>
                                                <span className="label">모든 프로젝트 :</span>
                                                <span>{totalProject}개</span>
                                            </div>
                                            <div>
                                                <span className="label">계약,진행중 :</span>
                                                <span>{runningProject}개</span>
                                            </div>
                                            <div>
                                                <span className="label">완료 :</span>
                                                <span>{doneProject}개</span>
                                            </div>
                                        </ProjectInfo>
                                    </Cell>

                                    {/* 회원등급 */}
                                    <Cell>{getGradeLabel(user)}</Cell>
                                </Row>

                                {openRow === user.id && (
                                    <DetailBox>
                                        <DetailColumn>
                                            <DetailRow>
                                                <span className="label">회사명:</span>
                                                <span>{user.company || '미작성'}</span>
                                            </DetailRow>
                                            <DetailRow>
                                                <span className="label">대표자명:</span>
                                                <span>{user.representative || '미작성'}</span>
                                            </DetailRow>
                                            <DetailRow>
                                                <span className="label">회사 형태:</span>
                                                <span>{user.companytype || '미작성'}</span>
                                            </DetailRow>
                                            <DetailRow>
                                                <span className="label">사무실 주소:</span>
                                                <span>
                                                    {(user.companyaddressf || '') + (user.companyaddressm || '') ||
                                                        '미작성'}
                                                </span>
                                            </DetailRow>
                                        </DetailColumn>

                                        <DetailColumn>
                                            <DetailRow>
                                                <span className="label">사업자 등록번호:</span>
                                                <span>{user.companyregiNum || '미작성'}</span>
                                            </DetailRow>
                                            <DetailRow>
                                                <span className="label">업태:</span>
                                                <span>{user.sector1 || '미작성'}</span>
                                            </DetailRow>
                                            <DetailRow>
                                                <span className="label">종목:</span>
                                                <span>{user.sector2 || '미작성'}</span>
                                            </DetailRow>
                                            <DetailRow>
                                                <span className="label">사무실 연락처:</span>
                                                <span>{user.companyNum || '미작성'}</span>
                                            </DetailRow>
                                        </DetailColumn>

                                        <DetailColumn>
                                            <DetailRow>
                                                <span className="label">세금계산서 메일:</span>
                                                <span>{user.taxmail || '미작성'}</span>
                                            </DetailRow>

                                            {/*  신원인증 파일 */}
                                            <DetailRow>
                                                <span className="label">신원인증 파일:</span>
                                                {user.file ? (
                                                    <FileLink
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            setModalFile(user.file)
                                                        }}
                                                    >
                                                        {user.file.split('/').slice(-1)[0]}
                                                    </FileLink>
                                                ) : (
                                                    <span>미작성</span>
                                                )}
                                            </DetailRow>

                                            {/*  신원인증 확인하기 버튼 */}
                                            <DetailRow>
                                                <span className="label">신원인증:</span>
                                                {user.identity ? (
                                                    <IdentityTag ok>완료</IdentityTag>
                                                ) : (
                                                    <IdentityButton
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            handleOkIdentity(user)
                                                        }}
                                                    >
                                                        신원인증 확인하기
                                                    </IdentityButton>
                                                )}
                                            </DetailRow>
                                        </DetailColumn>
                                    </DetailBox>
                                )}
                            </React.Fragment>
                        )
                    })}
                </Body>
            </Table>
            {/* 신원인증 파일 보기 모달 */}
            {modalFile && (
                <ModalInfoview
                    fileinfo={[modalFile, modalFile.split('.').pop()]}
                    isOpen={true}
                    userinfo={modalFile}
                    admin={true}
                    openModalHandler={() => setModalFile(null)}
                />
            )}
        </Wrap>
    )
}

export default AdminUserPage

// ===== styled =====
const Wrap = styled.div`
    width: 82%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
`

const FilterBar = styled.div`
    width: 95%;
    display: flex;
    justify-content: flex-start;
    gap: 8px;
    margin-bottom: 10px;
    margin-top: -10px;
`

const FilterButton = styled.button`
    padding: 6px 10px;
    border-radius: 4px;
    border: 1px solid ${(p) => (p.active ? '#2563eb' : '#d1d5db')};
    background: ${(p) => (p.active ? '#2563eb' : '#f9fafb')};
    color: ${(p) => (p.active ? '#ffffff' : '#111827')};
    font-size: 14px;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
        background: ${(p) => (p.active ? '#1d4ed8' : '#e5e7eb')};
    }
`

const Table = styled.div`
    width: 95%;
    border: 1px solid #ddd;
    background: #fff;
`

const Header = styled.div`
    display: grid;
    grid-template-columns: ${(p) => p.columns};
    background: #f1f3f7;
    border-bottom: 1px solid #ddd;
`

const HeaderCell = styled.div`
    border-right: 1px solid #ddd;

    &:last-child {
        border-right: none;
    }
`

const HeaderInner = styled.div`
    padding: 14px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    white-space: nowrap;

    .label {
        font-weight: bold;
        font-size: 18px;
    }
`

const SortWrap = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2px;
    font-size: 12px;
    cursor: pointer;
    svg {
        display: block;
        cursor: pointer;
    }
`

const Body = styled.div`
    width: 100%;
`

const Row = styled.div`
    display: grid;
    grid-template-columns: ${(p) => p.columns};
    text-align: center;
    cursor: pointer;
    border-bottom: 1px solid #eee;
    background: #fff;
    &:hover {
        background: #fafafa;
    }
`

const Cell = styled.div`
    padding: 10px 6px;
    border-right: 1px solid #eee;
    font-size: 14px;
    word-break: keep-all;

    /* 세로/가로 가운데 정렬 */
    display: flex;
    align-items: center;
    justify-content: center;

    &:last-child {
        border-right: none;
    }
`

const DetailBox = styled.div`
    padding: 18px 24px;
    background: #fdfdfd;
    border-bottom: 1px solid #eee;
    display: flex;
    gap: 20px;
`

const DetailColumn = styled.div`
    flex: 1;
    min-width: 0;
`

const DetailRow = styled.div`
    display: flex;
    margin-bottom: 6px;
    font-size: 14px;
    line-height: 1.4;

    .label {
        font-weight: bold;
        margin-right: 6px;
        white-space: nowrap;
    }

    > span:last-child {
        flex: 1;
        min-width: 0;
    }
`

const StatusWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: center;
`

const StatusBadge = styled.div`
    padding: 0px 6px;
    border-radius: 4px;
    background: ${(p) => (p.ok ? '#d1fae5' : '#fee2e2')};
    color: ${(p) => (p.ok ? '#065f46' : '#991b1b')};
    font-size: 14px;
    font-weight: 600;
`

const ProjectInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    font-size: 14px;
    text-align: center;

    .label {
        margin-right: 4px;
        font-weight: 600;
    }

    > div {
        display: flex;
        justify-content: left;
        gap: 4px;
    }
`

const IdentityTag = styled.span`
    /* padding: 2px 8px; */

    font-size: 14px;
    font-weight: 600;
    color: blue;
    /* background: ${(p) => (p.ok ? '#d1fae5' : '#fee2e2')}; */
    /* color: ${(p) => (p.ok ? '#065f46' : '#991b1b')}; */
`

const IdentityButton = styled.button`
    /* padding: 3px 8px; */
    border-radius: 4px;
    border: 1px solid #2563eb;
    background: #2563eb;
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
`

const FileLink = styled.span`
    color: #2563eb;
    text-decoration: underline;
    cursor: pointer;
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`
